export interface RegisterUsageStatisticsRequest {
  targetDate: string
  references: {
    referenceType: string
    inputs: {
      userType: string
      counter: number | string
    }[]
  }[]
  copies: {
    copyType: string
    counter: number | string
    counterNumber: number | string
  }[]
  events: {
    eventType: string
    counter: number | string
    inputs: {
      userType: string
      counter: number | string
    }[]
  }[]
  revision: number | null // null許容、nullの場合は新規登録として判定を取る
}

export function RegisterUsageStatisticsRequestToJSON(
  value: RegisterUsageStatisticsRequest
): any {
  return {
    target_date: value.targetDate !== '' ? value.targetDate : undefined,
    references:
      value.references.length > 0
        ? value.references.map(reference => {
            return {
              reference_type:
                reference.referenceType !== ''
                  ? reference.referenceType
                  : undefined,
              inputs:
                reference.inputs.length > 0
                  ? reference.inputs.map(input => {
                      return {
                        user_type:
                          input.userType !== '' ? input.userType : undefined,
                        counter: input.counter
                      }
                    })
                  : undefined
            }
          })
        : undefined,
    copies:
      value.copies.length > 0
        ? value.copies.map(copy => {
            return {
              copy_type: copy.copyType !== '' ? copy.copyType : undefined,
              counter: copy.counter,
              counter_number: copy.counterNumber
            }
          })
        : undefined,
    events:
      value.events.length > 0
        ? value.events.map(event => {
            return {
              event_type: event.eventType !== '' ? event.eventType : undefined,
              counter: event.counter,
              inputs:
                event.inputs.length > 0
                  ? event.inputs.map(input => {
                      return {
                        user_type:
                          input.userType !== '' ? input.userType : undefined,
                        counter: input.counter
                      }
                    })
                  : undefined
            }
          })
        : undefined,
    revision: value.revision ? value.revision : undefined // nullの場合があり得る、nullの場合は新規登録として処理を行っている
  }
}
